import { useCallback, useRef } from 'react';
import { useStartLoader, useStopLoader } from '../../store/modal/modalHooks';

declare const growPayment: {
  init: (config: any) => void;
  renderPaymentOptions: (token: string) => void;
};

type GrowPaymentCallbacks = {
  onSuccess?: (response: any) => void;
  onFailure?: (response: any) => void;
  onError?: (response: any) => void;
  onWalletChange?: (state: any) => void;
};

export function useGrowPayment() {
  const startLoading = useStartLoader();
  const stopLoading = useStopLoader();
  const sdkReady = useRef(false);

  const loadSdk = useCallback((): Promise<void> => {
    if (sdkReady.current) return Promise.resolve();

    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://cdn.meshulam.co.il/sdk/gs.min.js';
      script.onload = () => {
        sdkReady.current = true;
        resolve();
      };
      document.head.appendChild(script);
    });
  }, []);

  const openPayment = useCallback(
    async (token: string, callbacks: GrowPaymentCallbacks) => {
      await startLoading();
      await loadSdk();

      const config = {
        environment:
          process.env.NODE_ENV === 'development' ? 'DEV' : 'PRODUCTION',
        version: 1,
        events: callbacks,
      };

      const walletRoot = document.getElementById('Gr0W8-wallet-root');
      if (!walletRoot) {
        growPayment.init(config);
      }

      await new Promise((resolve) => setTimeout(resolve, 1000));

      growPayment.renderPaymentOptions(token);
      await stopLoading();
    },
    [loadSdk]
  );

  const closePayment = useCallback(() => {
    const walletRoot = document.getElementById('Gr0W8-wallet-root');
    if (walletRoot) {
      walletRoot.remove();
      console.log('Grow payment window deleted');
    } else {
      console.error('Grow payment window not found');
    }
  }, []);

  return {
    openPayment,
    closePayment,
  };
}
